import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';
import API_STATES from '@/constants/StateConstants';

const http = axios.create({
    baseURL: import.meta.env.REACT_APP_BASEURL,
});

/*
Watches auth token state changes to keep the request header in sync
*/

http.interceptors.request.use(async (config) => {
    if (firebase.auth().currentUser) {
        config.headers.Authorization = `Bearer ${await firebase.auth().currentUser.getIdToken()}`;
    }
    return config;
});

export async function getUserCount(requestBody) {
    try {
        const res = await http.post(`/message/custom_message/userCount`, { requestBody });
        return { status: API_STATES.success, data: res.data };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}


//call to create new message and return the response
export async function createSubscriptionBasedMessage(requestBody) {
    try {
        const res = await http.post(`/message/custom_message`, { requestBody });
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

export async function scheduleSubscriptionBasedNotification(requestBody){
    try {
        const res = await http.post(`/message/schedule_notification/subscription_based`, requestBody);
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

export async function getSubscriptionHistory(type) {
    try {
        const res = await http.get(`/message/messages_history/${type}`);
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

//detailed notification history
export async function getNotificationDetail(type, notificationId) {
    try {
        const res = await http.get(`/message/custom_message_detail/${type}/${notificationId}`);
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

export async function editAllMessages(requestBody) {
    try {
        const res = await http.post(`/message/custom_message_edit`, { requestBody });
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

// TODO : Add api call when edit functionality for single user is added
export async function editSingleUserMessage(requestBody){
    try {
        const res = await http.post(`/message/edit_companybased_message`, { requestBody });
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

export async function terminateMessage(requestBody) {
    try {
        const res = await http.post(`/message/terminate_userbased_messages`, { requestBody });
        return { status: API_STATES.success, data: res };
    } catch (error) {
        return { status: API_STATES.error, error: error };
    }
}

